import React, { memo } from "react";
import PropTypes from "prop-types";
import { SimulacoesDataGrid } from "../../organisms";
import {
  Button,
  Icon,
  IconButton,
  Stack,
  Typography,
} from "investira.react.components";

import { PageTemplate } from "../";

const SimulacoesTemplate = memo((props) => {
  const { initialState, state, ...restDataGridProps } = props.dataGridProps;

  return (
    <PageTemplate
      title={props.title}
      subtitle={props.subtitle}
      scrollable={false}
      headerRenderActions={props.headerRenderActions}
    >
      <SimulacoesDataGrid
        {...restDataGridProps}
        initialState={{
          ...initialState,
          density: "comfortable",
        }}
        state={state}
      />
    </PageTemplate>
  );
});

SimulacoesTemplate.propTypes = {
  data: PropTypes.array,
  isFetching: PropTypes.bool,
  readData: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default SimulacoesTemplate;
